import { render } from "./nav-bar-fw.vue?vue&type=template&id=634abf6e"
import script from "./nav-bar-fw.vue?vue&type=script&lang=js"
export * from "./nav-bar-fw.vue?vue&type=script&lang=js"

import exportComponent from "/Users/oscar/Desarrollo/Vue.js/FastWay/FastWayPro.005/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__